import { graphql } from "@opensea/graphql"
import { ProfileHeaderContentFragment } from "./ProfileHeaderContent.fragment"

export const ProfileHeaderFragment = graphql(
  `
    fragment ProfileHeader on Profile {
      bannerImageUrl
      address
      ...ProfileHeaderContent
    }
  `,
  [ProfileHeaderContentFragment],
)
